<template>
  <vh-container class="layout-container default">
    <div class="layout-main">
      <HeadBar v-if="hasHeadBar"></HeadBar>
      <router-view></router-view>
    </div>
  </vh-container>
</template>
<script>
  import HeadBar from '@/components/HeadBar.vue';
  import { initMsgChat } from '@/biz/base';

  export default {
    name: 'DefaultLayout',
    components: {
      HeadBar
    },
    props: {
      // 是否有消息监听
      hasMsgMonitor: {
        type: Boolean,
        default: false
      },
      // 是否有顶栏
      hasHeadBar: {
        type: Boolean,
        default: false
      }
    },
    created() {
      if (this.hasMsgMonitor) {
        initMsgChat();
      }
    }
  };
</script>
<style lang="less" scoped>
  .layout-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #f7f7f7;

    .layout-main {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  }
</style>
